import { getFirebaseToken } from "../../../services/firebase";

export async function isUserAuthentified() {
  return !!(await getFirebaseToken());
}
